<template>
    <div id="moduleWiseGL">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="cantAccessPage === true">
            <data-table-filter-config :moduleName="'moduleGlList'" ref="filterModuleGl" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white">
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'moduleGlList'">
                </custom-pagination>
                <vue-good-table
                    mode="remote"
                    ref="moduleGlList"
                    title="General Ledger"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-selected-rows-change="selectionChanged"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :isLoading=false
                    :search-options="{
                        enabled: false,
                    }"
                    :select-options="{
                        enabled: false,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                    }"
                    :sort-options="{
                        enabled: true,
                    }"
                >
                </vue-good-table>
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                </custom-pagination>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>    
    </div>    
</template>
<script>
import Vue from 'vue';
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
export default {
    name: "ModuleWiseGLList",
    metaInfo: {
        title: "FleetPro Application"
    },
    mixins:[commonMixins,dataTableMixins],
    props: {
        moduleName: {
                type: String,
                required: false,
                default:undefined
            },
        moduleId: {
            type: String,
            required: false,
            default:undefined
        }
    },
    data: () => ({
        firstLoad:0,
        userColumns:[],
        columns: [
            {
                label: 'Account',
                field: 'account_description',
                fpFieldType:"text",
                html: false,
                filterable: true,
                hidden:false,
            },
            {
                label: 'Reference',
                field: 'reference',
                fpFieldType:"text",
                html: false,
                filterable: true,
                hidden:false,
            },
            {
                label: 'Debit',
                field: 'debit',
                fpFieldType:"number",
                html: false,
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label: 'Credit',
                field: 'credit',
                fpFieldType:"text",
                html: false,
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label: 'Amount',
                field: 'journal_amount',
                fpFieldType:"text",
                html: false,
                filterable: false,
                hidden:false,
                sortable:false
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        permissions:[],
        cantAccessPage:'',
        action:'list'
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_general_ledger') {
                    self.cantAccessPage = true;
                }
            });
            if (self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    created: function() {
    
    },
    mounted: function () {

        var self = this;
        this.getPermissions();
        console.log(self.moduleName + ' ==== ' + self.moduleId);
    },
    methods: {
        loadList: function(){
            // $('#dataTableFilterConfig').removeClass('col-md-12 filter-section-main')
            var self = this;
            self.loading =  true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/gl-module/list",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: this.serverParams.columnFilters,
                    sort:self.serverParams.sort,
                    action:self.action,
                    module:self.moduleName,
                    module_id:self.moduleId
                },
                success: function (data) {
                    self.loading =  false;

                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.generateStatusCodeMessage(jqXHR, false, 'gl-module-list')
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ModuleWiseGLList.vue